import React from 'react';
import styles from './ImageThumbnail.module.scss';
import { DSInformationIcon } from '@design-system/icons';
import { Tooltip } from '@design-system/components';
import { AssetStep } from '@experiment-management-shared/types';

type ImagePanelLatestStepMessageProps = {
  currentStep: number | null;
  latestStep?: AssetStep;
};
const ImagePanelLatestStepMessage: React.FC<ImagePanelLatestStepMessageProps> = ({
  currentStep,
  latestStep
}) => {
  return (
    <div className={styles.latestStepInfo}>
      <Tooltip
        content={
          <div>
            <div>Displaying the most recent step: {latestStep ?? 1}</div>
            <div>No image was found for step {currentStep ?? 1}</div>
          </div>
        }
        wrapperDisplay="inline-flex"
      >
        <DSInformationIcon className={styles.latestStepInfoIcon} />
      </Tooltip>
    </div>
  );
};

export default ImagePanelLatestStepMessage;
